import guestRegisterActions from "@redux/feature/LoginFlow/actions/guestRegister";
import GetAccountDetailsActions from "@redux/feature/LoginFlow/actions/getAccountDetails";
import GuestValidateMPINActions from "@redux/feature/LoginFlow/actions/guestValidateMPIN";
import ClientLoginDataAction from "@redux/feature/LoginFlow/actions/ClientLoginData";
import UnblockUserActions from "@redux/feature/LoginFlow/actions/unblockUser";
import ClientForgotUserIDActions from "@redux/feature/LoginFlow/actions/ClientForgotUserID";
import ClientGenOTPActions from "@redux/feature/LoginFlow/actions/ClientGenOTP";
import ClientSetPasswordActions from "@redux/feature/LoginFlow/actions/ClientSetPassword";
import ClientValPasswordActions from "@redux/feature/LoginFlow/actions/ClientValPassword";
import ClientValOTPActions from "@redux/feature/LoginFlow/actions/ClientLoginValOTP";
import GuestEmailVerifyOTPActions from "@redux/feature/LoginFlow/actions/GuestEmailVerifyOTP";
import UpdateAccountDetails from "@redux/actions/userDetails";
export default (function () {
    return {
        login: {
            guestRegisterActions: new guestRegisterActions(),
            getAccountDetails: new GetAccountDetailsActions(),
            guestValidateMPIN: new GuestValidateMPINActions(),
            clientLoginDataActions: new ClientLoginDataAction(),
            unblockUser: new UnblockUserActions(),
            clientForgotUserID: new ClientForgotUserIDActions(),
            clientGenOTP: new ClientGenOTPActions(),
            clientSetPass: new ClientSetPasswordActions(),
            clientValPass: new ClientValPasswordActions(),
            clientValOTP: new ClientValOTPActions(),
            guestRegEmailVerifyOTP: new GuestEmailVerifyOTPActions(),
            updateAccountDetails: new UpdateAccountDetails(),
        },
    };
});
